import { DeviceState } from './DeviceState';

export class FineTuningDeviceStates {
    public deviceState: { [deviceId: string]: DeviceState };

    constructor(deviceState: { [deviceId: string]: DeviceState }) {
        this.deviceState = deviceState;
    }
}
